<script>
  import { cart, formdata, deliveryMethods, paymentServices } from './storage.js';
  import { updateCart, handleResponse, showErrors } from './requests.js';
  import Loader from '../components/Loader.svelte';
  import Money from './Money.svelte';
  import OrderItem from './OrderItem.svelte';

  let loading = false;

  const payload = {
    ...$formdata,
    token: $cart.token,
    status: 'placed'
  }

  if ($cart.all_digital) { 
    payload.payment_on_delivery = false;
  } else {
    payload.payment_on_delivery = $cart.payment_on_delivery;
    payload.delivery_method_id = $cart.delivery_method_id;
  }

  const finalize = () => {
    loading = true;
    
    updateCart($cart.id, payload)
    .then(handleResponse)
    .then(response => {
      loading = false;
      location.href = '/podsumowanie/' + response.data.token;
    })
    .catch(showErrors)
  };

  const selectedMethod = ($deliveryMethods ? $deliveryMethods : []).find(item => item['id'] === $cart.delivery_method_id);
</script>


<h1>Podsumowanie</h1>

<div class="row row-m1">
  <div class="box condensed">
    <p>
      <span class="bolder">Dane kontaktowe</span><br>
      <span class="smaller">
        {$formdata.email}
        {#if $formdata.phone}
          <br>{$formdata.phone}
        {/if}
      </span>
    </p>

    <p>
      <span class="bolder">Adres rozliczeniowy</span><br>
      <span class="smaller">
        {#if $formdata.billing_address_attributes.b2b}
          {$formdata.billing_address_attributes.company_name}, NIP {$formdata.tax_id}
          {#if $formdata.billing_address_attributes.first_name || $formdata.billing_address_attributes.last_name}<br>{/if}
        {/if}
        {$formdata.billing_address_attributes.first_name || ''} {$formdata.billing_address_attributes.last_name || ''}<br>
        {$formdata.billing_address_attributes.street} {$formdata.billing_address_attributes.building} {$formdata.billing_address_attributes.apartment || ''}<br>
        {$formdata.billing_address_attributes.zipcode} {$formdata.billing_address_attributes.city}
      </span>
    </p>

    {#if $formdata.comment}
      <p>
        <span class="bolder">Uwagi do zamówienia</span><br>
        <span class="smaller">{$formdata.comment.replace(/(?:\r\n|\r|\n)/g, '<br>')}</span>
      </p>
    {/if}
  </div>

  <div class="box condensed">
    <p>
      <span class="bolder">Dostawa</span><br>
      <span class="smaller">
        {#if $cart.all_digital}
          E-mail
        {:else}
          {selectedMethod.name} ({$cart.delivery_price_with_currency})
        {/if}
      </span>
    </p>
    <p>
      {#if $formdata.delivery_address_attributes}
        <span class="bolder">Adres dostawy</span><br>
        <span class="smaller">
          {$formdata.delivery_address_attributes.first_name} {$formdata.delivery_address_attributes.last_name}<br>
          {$formdata.delivery_address_attributes.street} {$formdata.delivery_address_attributes.building} {$formdata.billing_address_attributes.apartment || ''}<br>
          {$formdata.delivery_address_attributes.zipcode} {$formdata.delivery_address_attributes.city}
        </span>
      {:else if !$cart.all_digital}
        <span class="bolder">Dostawa pod ten sam adres.</span>
      {/if}
    </p>

    <p>
      
      {#if $cart.payment_on_delivery}
        <span class="bolder">Płatność przy odbiorze.</span>
      {:else}
        <span class="bolder">Płatność z góry</span><br>
        <span class="smaller">
          Dostępne formy płatności:
          {#if $paymentServices}
            { $paymentServices.map(item => item.name).join(', ') }.
          {/if}
        </span>
      {/if}
    </p>
  </div>
</div>

<div class="box">
  {#each $cart.order_items as item}
    <OrderItem {item} />
  {/each}
</div>

<Money />

<div class="actions">
  {#if loading}
    <Loader />
  {:else}
    <button class="button" on:click={finalize}>Składam zamówienie</button>
  {/if}
</div>


<style>
  .box {
    border: 1px solid #e0e0e0;
    margin-bottom: 15px;
    padding: 20px 25px;
  }

  .box p:last-of-type {
    margin-bottom: 0;
    padding-bottom: 0;
  }

  @media (max-width: 767px) {
    .box {
      margin-bottom: 10px;
      padding: 10px;
    }
  }
</style>
